import React from "react";
import {css} from "@emotion/react";

import {mb, mv, onDesktop} from "@pg-design/helpers-css";
import {Highlight, Text} from "@pg-design/text-module";

import {ShowMoreButton} from "../../../atoms/ShowMoreButton";
import {VendorDetailSoldOfferBox, VendorDetailSoldOfferBoxProps} from "./boxes/VendorDetailSoldOfferBox";

interface IProps {
    offers: VendorDetailSoldOfferBoxProps["offer"][];
    vendorSlug: VendorDetailSoldOfferBoxProps["vendorSlug"];
}

const VendorDetailSoldList: React.FC<IProps> = ({vendorSlug, offers}) => (
    <ul css={soldOffersList}>
        {offers.map((offer) => (
            <li key={offer.id} css={[mv(2), onDesktop(mv(3))]}>
                <VendorDetailSoldOfferBox offer={offer} vendorSlug={vendorSlug} />
            </li>
        ))}
    </ul>
);

export const VendorDetailSoldOffers = (props: IProps) => {
    const {offers, vendorSlug} = props;

    return (
        <>
            <Text as="h2" variant="headline_3" css={[mb(3), onDesktop(mb(5))]}>
                Zakończyliśmy sprzedaż <Highlight>{offers.length} inwestycji</Highlight>
            </Text>

            <VendorDetailSoldList offers={offers.slice(0, 5)} vendorSlug={vendorSlug} />

            {offers.length > 5 && (
                <ShowMoreButton showMoreText="Pokaż więcej inwestycji" showLessText="Pokaż mniej inwestycji">
                    <VendorDetailSoldList offers={offers.slice(5)} vendorSlug={vendorSlug} />
                </ShowMoreButton>
            )}
        </>
    );
};

const soldOffersList = css`
    list-style: none;
    padding-left: 0;
    margin: 0;
`;
import React from "react";
import {css} from "@emotion/react";

import {mb, mv, onDesktop} from "@pg-design/helpers-css";
import {Highlight, Text} from "@pg-design/text-module";

import {ShowMoreButton} from "../../../atoms/ShowMoreButton";
import {VendorDetailSoldOfferBox, VendorDetailSoldOfferBoxProps} from "./boxes/VendorDetailSoldOfferBox";

interface IProps {
    offers: VendorDetailSoldOfferBoxProps["offer"][];
    vendorSlug: VendorDetailSoldOfferBoxProps["vendorSlug"];
}

const VendorDetailSoldList: React.FC<IProps> = ({vendorSlug, offers}) => (
    <ul css={soldOffersList}>
        {offers.map((offer) => (
            <li key={offer.id} css={[mv(2), onDesktop(mv(3))]}>
                <VendorDetailSoldOfferBox offer={offer} vendorSlug={vendorSlug} />
            </li>
        ))}
    </ul>
);

export const VendorDetailSoldOffers = (props: IProps) => {
    const {offers, vendorSlug} = props;

    return (
        <>
            <Text as="h2" variant="headline_3" css={[mb(3), onDesktop(mb(5))]}>
                Zakończyliśmy sprzedaż <Highlight>{offers.length} inwestycji</Highlight>
            </Text>

            <VendorDetailSoldList offers={offers.slice(0, 5)} vendorSlug={vendorSlug} />

            {offers.length > 5 && (
                <ShowMoreButton showMoreText="Pokaż więcej inwestycji" showLessText="Pokaż mniej inwestycji">
                    <VendorDetailSoldList offers={offers.slice(5)} vendorSlug={vendorSlug} />
                </ShowMoreButton>
            )}
        </>
    );
};

const soldOffersList = css`
    list-style: none;
    padding-left: 0;
    margin: 0;
`;
